<template>
    <client-page>
        <div id="contents">
            <v-container>
                <div class="title-wrap title-wrap--line">
                    <h2 class="font-42">라이브러리 게시판</h2>
                </div>
                <library-list></library-list>
            </v-container>
        </div>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/ko/templates/ClientPage.vue";
import LibraryList from "@/components/client/ko/board/library/list.vue"

export default {
    components: {
        ClientPage,
        LibraryList
    },
};
</script>